module.exports = __webpack_public_path__ + "ui-bg_glass_65_ffffff_1x400.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-bg_glass_65_ffffff_1x400.png
// module id = 806
// module chunks = 1